<ng-container [formGroup]="form">
  <div class="row cl-spacing-small">
    <div class="col-4">
      <label class="form-label" for="encrypt">Encryption</label>
      <select class="form-select" formControlName="encrypt" id="encrypt">
        <option [ngValue]="false">Plain</option>
        <option [ngValue]="true">Encrypt</option>
      </select>
    </div>
  </div>
</ng-container>

